export default {
  path: '/ratio-deals',
  meta: {
    title: '兑换积分交易',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-deals`),
}



// WEBPACK FOOTER //
// ./src/views/RatioDeal/router.js